<div class="chat-status-container">
    <span class="chat-response chat-response-status"
        [class.chat-response-status-complete]="!isTyping && displayedText">{{ displayedText }}</span><span
        class="typing-cursor" *ngIf="isTyping"></span>
</div>
